export const normalizePostRealtimeId = (value) => {
  if (value === undefined || value === null) return '';
  if (typeof value === 'object' && value._id && value._id !== value) {
    return normalizePostRealtimeId(value._id);
  }
  return String(value);
};

export const getPostRealtimeId = (post) =>
  normalizePostRealtimeId(post?._id || post?.id || post?.postId);

export const applyPostEditToPost = (post, payload = {}) => {
  const postId = normalizePostRealtimeId(payload.postId);
  if (!post || !postId || getPostRealtimeId(post) !== postId) return post;
  if (typeof payload.desc !== 'string') return post;

  return {
    ...post,
    desc: payload.desc,
    ...(payload.updatedAt ? { updatedAt: payload.updatedAt } : {}),
  };
};

export const applyPostEditToItems = (items = [], payload = {}) => {
  if (!Array.isArray(items)) return items;
  return items.map((item) => applyPostEditToPost(item, payload));
};

export const mergeUntrustedPostUpdate = (currentPost, incomingPost) => {
  if (!currentPost || !incomingPost) return currentPost || incomingPost;
  if (getPostRealtimeId(currentPost) !== getPostRealtimeId(incomingPost)) {
    return currentPost;
  }

  return {
    ...currentPost,
    ...incomingPost,
    desc: currentPost.desc,
  };
};
